import { Modal } from './ui';
import type { SplitSummary } from '../types/api';
import ClassCoveragePreview from './ClassCoveragePreview';

/**
 * G.6 (UX revision 2026-06-07) — read-only modal showing the locked
 * project's full dataset split summary.
 *
 * Replaces the inline sidebar banner-expansion pattern, which ate
 * vertical space in the image list and blocked image scrolling. The
 * compact summary now lives in the top "Project is locked" banner;
 * clicking "View details" opens this modal.
 *
 * Reuses ClassCoveragePreview without modification — same wire shape,
 * same table, same suggestions panel. The modal is just a thin
 * positioning + dismissal wrapper.
 */
interface SplitDetailsModalProps {
    open: boolean;
    summary: SplitSummary | null;
    isDarkMode?: boolean;
    onClose: () => void;
}

export default function SplitDetailsModal({
    open,
    summary,
    isDarkMode = false,
    onClose,
}: SplitDetailsModalProps) {
    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Dataset split"
            widthClass="max-w-3xl"
            isDarkMode={isDarkMode}
        >
            <ClassCoveragePreview
                summary={summary}
                isDarkMode={isDarkMode}
                showHeader
            />
        </Modal>
    );
}
